import {
  ShortAnswerData,
  ShortAnswerElement,
} from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext, useState } from "react";
import { BrandKitTextInput } from "../../brand-kit-text-input";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import { BrandKitContext } from "../review-form-editor-contexts";

export const ReviewsShortAnswer = memo(function ReviewsShortAnswer({
  element,
  setData,
  data,
  showRequired,
}: {
  element: ShortAnswerElement;
  data?: ShortAnswerData;
  setData: (data: ShortAnswerData) => void;
  showRequired: boolean;
}) {
  const brandKit = useContext(BrandKitContext);

  const [value, setValue] = useState("");

  function handleSetValue(value: string) {
    setValue(value);
    setData?.({ type: element.type, answer: value });
  }

  const realValue = data?.answer || value;

  const fontFamily = brandKit.font.bodyFontFamily; // NOTE: Assuming body font is used for short answer

  const showRequiredState = showRequired && element.required;

  return (
    <Flex dir="column" style={{ fontFamily }}>
      <Text fontSize="sm" fontWeight="medium">
        {element.title}
      </Text>
      <BrandKitTextInput
        brandKit={brandKit}
        placeholder={element.placeholderText}
        setValue={handleSetValue}
        state={showRequiredState ? "error" : "default"}
        value={realValue}
      />
      {showRequiredState && (
        <Text fontSize="sm" style={{ fontFamily }} textColor="error">
          This question is required
        </Text>
      )}
    </Flex>
  );
});

export const shortAnswerInspector: InspectorConfig<ShortAnswerElement> = {
  sections: [
    {
      label: "Short Answer",
      description: "Customize this short answer element",
      fields: [
        { widget: "toggle", path: "required", label: "Required" },
        { widget: "text", path: "title", label: "Title" },
        { widget: "text", path: "placeholderText", label: "Placeholder text" },
      ],
    },
  ],
};
